import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LookupRequestInfo } from './lookup-grid.component';
import { LookupDialogApi } from './lookup-dialog.api';

@Injectable()
export class LookupDialogService {

  private _entityType: number;

  get entityType(): number {
    return this._entityType;
  }
  set entityType(value: number) {
    this._entityType = value;
  }

  constructor(private lookupDialogApi: LookupDialogApi) {
  }

  getAutocompleteOptions(searchTerm: string): Observable<any> {
    return this.lookupDialogApi.getAutocompleteOptions(searchTerm, this.entityType, 10);
  }

  getRecords(pageInfo: LookupRequestInfo) {    
    return this.lookupDialogApi.getRecords(pageInfo);
  }

  getEntityViews(pageInfo: LookupRequestInfo) {
    return this.lookupDialogApi.getEntityViews(pageInfo);
  }

}




